module.exports = __webpack_public_path__ + "static/media/off games.16fd0ff3.svg";